import { render, staticRenderFns } from "./GoalsChart.vue?vue&type=template&id=3b5f8fa8&scoped=true"
import script from "./GoalsChart.vue?vue&type=script&lang=ts"
export * from "./GoalsChart.vue?vue&type=script&lang=ts"
import style0 from "./GoalsChart.vue?vue&type=style&index=0&id=3b5f8fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f8fa8",
  null
  
)

export default component.exports